export default __webpack_public_path__ + "static/g101-d45c5e265a744986cd91621337b37be2.jpg";